"use strict";

exports.__esModule = true;
exports["default"] = Hamburger20;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Hamburger20(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 2.5c0 .8-.7 1.5-1.5 1.5h-17C.7 4 0 3.3 0 2.5S.7 1 1.5 1h17c.8 0 1.5.7 1.5 1.5zM20 9.5c0 .8-.7 1.5-1.5 1.5h-17C.7 11 0 10.3 0 9.5S.7 8 1.5 8h17c.8 0 1.5.7 1.5 1.5zM20 16.5c0 .8-.7 1.5-1.5 1.5h-17C.7 18 0 17.3 0 16.5S.7 15 1.5 15h17c.8 0 1.5.7 1.5 1.5z"
  }));
}